module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_25.943e43cf.png";